import { Alert, Link, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

export const CompanyPageNotConfiguredModal = ({ onClose }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Modal
      illustration="alert"
      title={i18n.t('company_page.not_configured_modal.title')}
      description={i18n.t('company_page.not_configured_modal.description')}
      onClose={onClose}
    >
      <Alert color="warning">
        <Text.Normal>
          {i18n.t('company_page.not_configured_modal.warning')}{' '}
          <Link.Router to={navigation.settings.company_page.fullPath()}>
            {i18n.t('company_page.not_configured_modal.setup')}
          </Link.Router>
        </Text.Normal>
      </Alert>
    </Modal>
  )
}
